import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./App.css";
import ScrollToTop from "./Components/AutoScroll/ScrollToTop";
import { BrowserRouter } from "react-router-dom";
import { GlobalProvider } from "./Context/GlobalContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <BrowserRouter>
    <ScrollToTop />
    <GlobalProvider>
      <App />
    </GlobalProvider>
    </BrowserRouter>
);